import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelStandbyCancelResultRequest,
  failStandbyCancelResult,
  setStandbyCancelResult,
  setStandbyCancelResultFromApi,
  updateStandbyCancelResult,
  updateStandbyCancelResultFromApi,
} from './standby-cancel-result.actions';

/**
 * Service to handle async StandbyCancelResult actions
 */
@Injectable()
export class StandbyCancelResultEffect {
  /**
   * Set the state with the reply content, dispatch failStandbyCancelResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setStandbyCancelResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setStandbyCancelResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failStandbyCancelResult({ error, requestId: action.requestId })),
        cancelStandbyCancelResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failStandbyCancelResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateStandbyCancelResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateStandbyCancelResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failStandbyCancelResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
